import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Navigation from './Navigation';
import { logger } from '../../services/logger';
import { WindowContainer } from '../../components/windows';
import { ToastContainer } from '@/components/ui/Toast';

/**
 * Main application layout with navigation and content area
 */
const AppLayout: React.FC = () => {
  const [isDarkMode, setIsDarkMode] = useState(() => {
    return document.documentElement.classList.contains('dark');
  });
  
  // Listen for changes to the dark mode class on the document
  useEffect(() => {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'class') {
          setIsDarkMode(document.documentElement.classList.contains('dark'));
        }
      });
    });
    
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class'],
    });
    
    return () => observer.disconnect();
  }, []);
  
  // Log theme changes
  useEffect(() => {
    logger.debug(`Using ${isDarkMode ? 'dark' : 'light'} mode in layout`);
  }, [isDarkMode]);
  
  return (
    <div className={`min-h-screen ${isDarkMode ? 'bg-gray-900 text-white' : 'bg-gray-50 text-gray-900'}`}>
      <Navigation />
      <main className="container mx-auto px-4 py-4">
        <Outlet />
      </main>
      <footer className="mt-8 py-4 border-t border-gray-200 dark:border-gray-800">
        <div className="container mx-auto px-4 text-center text-sm text-gray-500 dark:text-gray-400">
          &copy; {new Date().getFullYear()} PhishPhind - LLM-powered phishing email analysis
        </div>
      </footer>
      
      {/* Window container for rendering windows */}
      <WindowContainer className="fixed z-50" />
      <ToastContainer />
    </div>
  );
};

export default AppLayout; 